import { render, staticRenderFns } from "./generic_column_name_edition_for_renaming.vue?vue&type=template&id=4521ccc8&"
import script from "./generic_column_name_edition_for_renaming.vue?vue&type=script&lang=js&"
export * from "./generic_column_name_edition_for_renaming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports